import classNames from "classnames";
import { noop } from "es-toolkit";
import type { PropsWithChildren } from "react";
import { useWatch } from "react-hook-form";
import { ContentContainer } from "../../ContentContainer";
import { IconButton } from "../../IconButton";
import { Loader } from "../../Loader";
import { bgStyles, flexStyles, iconStyles, loaderStyles, pointerStyles, positionStyles } from "../../styles";
import type { PropsWithName } from "../../types";

interface Props extends PropsWithChildren, PropsWithName {
  prompt: string;
  uploading: boolean;
  round?: boolean;
}
export function FileDrop({ name, children, prompt, uploading, round = false }: Props) {
  const value = useWatch({ name });

  return (
    <ContentContainer
      round={round}
      label={prompt}
      iconType="UploadCloud"
      forcePrompt={!uploading && !value}
      className={classNames(positionStyles.relative, loaderStyles.businessDark, flexStyles.alignSelfStretch)}
    >
      {uploading && <Loader />}
      {!uploading && value && (
        <IconButton
          className={classNames(
            positionStyles.absolute,
            positionStyles.right0,
            positionStyles.bottom0,
            positionStyles.zIndex3,
            pointerStyles.eventsNone,
            iconStyles.neutral0,
            bgStyles.primary,
            iconStyles.buttonDimensions375,
          )}
          onClick={noop}
          iconType="Edit"
        />
      )}
      {children}
    </ContentContainer>
  );
}
